import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Typography from 'components/Luxkit/Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { loyaltyLandingPageBenefitTiles } from '../LoyaltyLandingPageData'
import LoyaltyLandingPageLargeTile from './LoyaltyLandingPageLargeTile'
import LoyaltyLandingPageSmallTile from './LoyaltyLandingPageSmallTile'

const BenefitsSection = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(68)} 0;
  }
`

const SmallTilesSection = styled.div`
  display: grid;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const largeTiles = [
  loyaltyLandingPageBenefitTiles.upgrades,
  loyaltyLandingPageBenefitTiles.transfers,
  loyaltyLandingPageBenefitTiles.lounge,
]

const smallTiles = [
  loyaltyLandingPageBenefitTiles.support,
  loyaltyLandingPageBenefitTiles.travelshoot,
  loyaltyLandingPageBenefitTiles.tourExtras,
]

interface Props {
  onActivate?: () => void;
}

function LoyaltyUserBronzeBenefits(props: Props) {
  const { onActivate } = props

  const isLoyaltyMember = useAppSelector(state => !!state.loyalty.account.data)

  return <BenefitsSection type="light-grey">
    <VerticalSpacer gap={32}>
      <VerticalSpacer gap={8}>
        <Heading variant="heading2" align="center">Where loyalty meets luxury</Heading>
        {isLoyaltyMember && <BodyText variant="large" align="center">
          Every booking brings you closer to unlocking VIP benefits,{' '}
          adding more luxury to every escape.
        </BodyText>}
      </VerticalSpacer>
      <VerticalSpacer gap={48}>
        <VerticalSpacer gap={36}>
          {largeTiles.map((tile, index) => <LoyaltyLandingPageLargeTile
            reverse={index % 2 === 0}
            tile={tile}
            key={index}
          />)}
        </VerticalSpacer>
        <SmallTilesSection>
          {smallTiles.map(tile => <LoyaltyLandingPageSmallTile key={tile.title} tile={tile} />)}
        </SmallTilesSection>
        {onActivate && <Typography align="center">
          <TextButton kind="primary" onClick={onActivate}>
            Activate your free membership
          </TextButton>
        </Typography>}
      </VerticalSpacer>
    </VerticalSpacer>
  </BenefitsSection>
}

export default LoyaltyUserBronzeBenefits
